class TestModel {
  // 下单日期开始时间
  public submitDateStart: string;
  // 下单日期截止时间
  public submitDateEnd: string;
  // 审核开始时间
  public verifyTimeStart: string;
  // 审核结束时间
  public verifyTimeEnd: string;
  // 出行时间开始时间
  public goTimeStart: string;
  // 出行时间截止时间
  public goTimeEnd: string;
  // 交易状态来源
  public orderPayStatusFrom: string;
  // 交易状态
  public orderPayStatus: string;
  // 分阶状态
  public stepStatus: string;
  // 子订单编号
  public itemNumber: string;
  // 客服
  public headId: string;
  // 确认函
  public isMail: string;
  // 国家id
  public countryId: string;
  // 城市id
  public cityId: string;
  // 商品分类
  public categoryId: string;
  // 订单来源
  public fromSource: string;
  // 即时确认
  public isImmediate: string;
  // 联系人姓名
  public contactName: any;
  // 联系电话
  public phone: any;
  // 天猫短码
  public tMallCode: any;
  // SKU名称
  public skuName: any;
  // 供应商
  public supplierCode: any;
  // 行程公司
  public travelCompany: any;
  // 新增详情
  public addRemark: any;
  // 团号
  public groupNumber: any;
  // 客人账号
  public account: any;
  // 订单状态
  public orderStatus: number[];
  // 订单标签
  public tag: number[];
  // 目的地
  public destination: string;
  // 查询历史订单
  public queryHistory: number;

  constructor() {
    this.submitDateStart = "";
    this.submitDateEnd = "";
    this.verifyTimeStart = "";
    this.verifyTimeEnd = "";
    this.goTimeStart = "";
    this.goTimeEnd = "";
    this.orderPayStatusFrom = "";
    this.orderPayStatus = "";
    this.stepStatus = "";
    this.itemNumber = "";
    this.headId = "";
    this.isMail = "";
    this.countryId = "";
    this.cityId = "";
    this.categoryId = "";
    this.fromSource = "";
    this.isImmediate = "";
    this.contactName = "";
    this.phone = "";
    this.tMallCode = "";
    this.skuName = "";
    this.supplierCode = "";
    this.travelCompany = "";
    this.addRemark = "";
    this.groupNumber = "";
    this.account = "";
    this.orderStatus = [];
    this.tag = [];
    this.destination = "";
    this.queryHistory = 0;
  }

  // 映射为标题
  static mapToLabel(field) {
    switch (field) {
      case "submitDate":
        return {
          label: "下单日期",
          sort: 1
        };
      case "verifyTime":
        return {
          label: "审核日期",
          sort: 2
        };
      case "goTime":
        return {
          label: "出行日期",
          sort: 3
        };
      case "orderPayStatus":
        return {
          label: "交易状态",
          sort: 4
        };
      case "stepStatus":
        return { label: "分阶状态", sort: 5 };
      case "itemNumber":
        return { label: "子订单编号", sort: 6 };
      case "headId":
        return { label: "客服", sort: 7 };
      case "isMail":
        return { label: "确认函", sort: 8 };
      case "countrycity":
        return {
          label: "国家城市",
          sort: 9
        };
      case "categoryId":
        return { label: "商品分类", sort: 10 };
      case "fromSource":
        return { label: "订单来源", sort: 11 };
      case "isImmediate":
        return { label: "即时确认", sort: 12 };
      case "contactName":
        return { label: "联系人姓名", sort: 13 };
      case "phone":
        return { label: "联系电话", sort: 14 };
      case "tMallCode":
        return { label: "天猫短码", sort: 15 };
      case "skuName":
        return { label: "SKU名称", sort: 16 };
      case "supplierCode":
        return { label: "供应商", sort: 17 };
      case "travelCompany":
        return { label: "行程公司", sort: 18 };
      case "addRemark":
        return { label: "新增详情", sort: 19 };
      case "groupNumber":
        return { label: "团号", sort: 20 };
      case "account":
        return { label: "客人账号", sort: 21 };
      case "orderStatus":
        return { label: "订单状态", sort: 22 };
      case "tag":
        return { label: "订单标签", sort: 23 };
      case "destination":
        return { label: "目的地", sort: 24 };
      default:
        return null;
    }
  }

  // 映射为显示的字段
  static mapToField(field) {
    switch (field) {
      case "submitDate":
        return ["submitDateStart"];
      case "verifyTime":
        return ["verifyTimeStart"];
      case "goTime":
        return ["goTimeStart"];
      case "countrycity":
        return ["countryId"];
      default:
        return [field];
    }
  }

  // 映射为显示的字段 field: string| Array
  static mapToAssociatedField(field) {
    console.log("AssocField", field);
    let _field: any;
    if (typeof field === "string") {
      _field = field;
    } else if (field instanceof Array && field.length > 0) {
      _field = field[0];
    } else {
      console.log("mapToAssociatedField", "没有匹配到数据");
      return [];
    }

    const list = [
      ["submitDateStart", "submitDateEnd"],
      ["verifyTimeStart", "verifyTimeEnd"],
      ["goTimeStart", "goTimeEnd"],
      ["orderPayStatus", "orderPayStatusFrom"],
      ["countryId", "cityId"],
      ["fromSource", "fromSource_extField1"]
    ];

    console.log(list);

    for (const fieldList of list) {
      if (
        fieldList.some(element => {
          return element == _field;
        })
      ) {
        return fieldList;
      }
    }

    return null;
  }
}

export default TestModel;
